module.exports = __webpack_public_path__ + "img/qrcode-qxkj.622b5098.jpg";